export default "__VITE_ASSET__DaozDI8R__"